import { makeStyles } from '@material-ui/core';

export default makeStyles((theme) => ({
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    alignContent: 'center',
    width: '100%',
    height: '100%',
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[3],
    alignContent: 'center',
    outline: 'none',
  },
  closeIcon: {
    position: 'absolute',
    fontSize: '2.325rem',
    top: '0.825rem',
    right: '2rem',
    cursor: 'pointer',
    color: theme.palette.colors.grey,
  },
  header: {
    position: 'relative',
    backgroundColor: theme.palette.colors.lightGrey,
    borderBottom: `1px solid ${theme.palette.colors.grey}`,
    padding: '1rem 2.5rem',
    width: '100%',
    justifyContent: 'center',
    display: 'flex',
    flexWrap: 'nowrap',
    fontSize: '1.125rem',
    fontWeight: 600,
    alignItems: 'center',
    textAlign: 'bottom',
  },
  content: {
    padding: theme.spacing(2, 4, 3),
    display: 'flex',
    flexFlow: 'column',
    gap: '40px',
    position: 'relative',
  },
  buttonPosition: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
  },
  centerText: {
    textAlign: 'center',
  },
}));
